import { authService } from './authService';

const getCompanyParam = () => {
  const id = authService.getCompanyId();
  return id ? `companyId=${id}` : '';
};

const apiFetch = async (url, options = {}) => {
  const res = await fetch(url, {
    ...options,
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...options.headers },
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.message || `Request failed: ${res.status}`);
  }
  if (res.status === 204) return null;
  const text = await res.text();
  return text ? JSON.parse(text) : null;
};

export const channelService = {
  getChannels: (chatbotId) =>
    apiFetch(`/api/chatbots/${chatbotId}/channels?${getCompanyParam()}`),

  createChannel: (chatbotId, data) =>
    apiFetch(`/api/chatbots/${chatbotId}/channels?${getCompanyParam()}`, {
      method: 'POST',
      body: JSON.stringify(data),
    }),

  updateChannel: (chatbotId, channelId, data) =>
    apiFetch(`/api/chatbots/${chatbotId}/channels/${channelId}?${getCompanyParam()}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    }),

  deleteChannel: (chatbotId, channelId) =>
    apiFetch(`/api/chatbots/${chatbotId}/channels/${channelId}?${getCompanyParam()}`, { method: 'DELETE' }),

  toggleChannel: (chatbotId, channelId) =>
    apiFetch(`/api/chatbots/${chatbotId}/channels/${channelId}/toggle?${getCompanyParam()}`, { method: 'PUT' }),
};
